import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { LabRequisitionStatus } from 'src/app/enum/water-lab/LabRequisitionStatus';
import { AccessUserInfo, UserDetail } from 'src/app/models';
import { LabRequestService, LabRequisitionService, MessageService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';
import { WorkFlow } from "src/app/enum/water-lab/workFlow"
import{PreferredLabName} from 'src/app/enum/water-lab/preferredLab'
import { CustomDatePipe } from 'src/app/pipes';

import * as ZoneMoment from "moment-timezone";

var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.vfs;
var htmlToPdfmake = require("html-to-pdfmake");

@Component({
  selector: 'bart-print-manifest',
  templateUrl: './print-manifest.component.html',
  styleUrls: ['./print-manifest.component.scss'],
  providers:[CustomDatePipe]
})
export class PrintManifestComponent implements OnInit {
  @Output() pageLoadCompletedEvent = new EventEmitter();
  @Input() facilityDisplayName:string; 
  @Input() selectedFacilityMasterId:number;
  @Input() reprint:boolean;
  @Input() labRequisitionIds:string;
  @Input() workFlow:string="";
  @Input()  shippingDate:Date=new Date();
  @Input() ShippingManifestID:string="";
  @Input() IsHistoricalManifest:boolean=false;
 loboratoryDetails:any;
 facilityDetails: any;
 testEquipmentTblData:any = [];
 userInfo:UserDetail;
 printDate:Date;
 testCount:number = 0;
 containerCount:number = 0;
 preferredLabName:string;
  constructor(
    private _labRequestService:LabRequestService,
    private _loaderService: LoaderService,
    private _messageService: MessageService,
    private _labRequisitionService:LabRequisitionService,
    private customDatePipe :CustomDatePipe,
  ) { }

  ngOnInit() {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.printDate = new Date();
    this.preferredLabName=PreferredLabName.name;
    this.populatePDFDate();
  }

  populatePDFDate(){
    this.facilityDetails = [];
    this.loboratoryDetails = [];
    let getFacilityParam = {
      "GETFACILITYINFO": {
        "facilityMasterId": this.selectedFacilityMasterId
      }
    }

    let getLabratoryParam = {
      "GETLABORATORY": {
        "FacilityMasterID": this.selectedFacilityMasterId,
      }
    }

    let printShippingManifestParam = {
      "PRINTSHIPPINGMANIFEST": {
        "LabRequisitionID": this.labRequisitionIds,
        "IsHistoricalManifest":this.IsHistoricalManifest
      }
    }

    const FacilityDetailsURL = this._labRequisitionService.getfacilityDetails(JSON.stringify(getFacilityParam));   
    const testEquipmentURL = this._labRequisitionService.printShippingManifest(JSON.stringify(printShippingManifestParam));
    const requestsArray = [];
    requestsArray.push(FacilityDetailsURL,testEquipmentURL);
   // this._loaderService.show();
    forkJoin(requestsArray).subscribe((response: any) => {
      //this._loaderService.hide();
      if(response!=null && response[0].length){
        this.facilityDetails = response[0][0];
      }      

      if(response!=null && response[1]!=null && response[1].printShippingManifest){        
        this.testEquipmentTblData = response[1].printShippingManifest;        
        this.containerCount = this.testEquipmentTblData.length;
        //Start:PCR-007.1: Lab NEW Requirement - Lab New Profile Code 0386 [FREQ-774268] 
        let isSpecialEdgeCaseCount=this.testEquipmentTblData.filter(x=>x.TestDisplayName.startsWith("0386 |")|| x.TestDisplayName.startsWith("0387 |")).length;
        if(isSpecialEdgeCaseCount>0)
        {
          this.containerCount=this.containerCount+isSpecialEdgeCaseCount;
        }
        //End:PCR-007.1: Lab NEW Requirement - Lab New Profile Code 0386 [FREQ-774268] 

        this.testEquipmentTblData = this.testEquipmentTblData.filter(x=>x.IsSWAB==false);        
        this.testCount = this.testEquipmentTblData.length;
        this.testEquipmentTblData.forEach(itm=>{
          if(itm.ContainerID.indexOf('|')>1){
            itm.ContainerDetails="";
            itm.ContainerID.split('|').forEach((x,index)=>
              {
                itm.ContainerDetails =itm.ContainerDetails+ (index>0?"; "+x.trim():""+ x.trim())+" | "+itm.ContainerDescription.split('|')[index].trim()
              })
            
          }
          else{
            itm.ContainerDetails=itm.ContainerID+" | "+itm.ContainerDescription;
          }
        })      
  
      this.createPDF();
      }
      else{
        this._messageService.showAlertMessage("Error:Some Error Occured. You may reach out to your administrator.");
        this._loaderService.hide();
      }

    }, (error) => {
      this._loaderService.hide();
      this._messageService.setErrorPageMessage('Error Occurred while loading Master Data');
    }
    )
  }

 
  createPDF(){ 
    var timeZoneOffset = (new Date(this.printDate)).getTimezoneOffset();
    var timeZone = ZoneMoment.tz.guess();
    let currentTimezone =  ZoneMoment.tz.zone(timeZone).abbr(timeZoneOffset);
    let printFooterDate=this.customDatePipe.transform(this.printDate,"calender","MM/dd/yyyy HH:mm:ss")+" "+currentTimezone 
    // let printFooterDate=this.customDatePipe.transform(this.printDate,"calender","MM/dd/yyyy HH:mm:ss")
    let footerLine1=this.facilityDisplayName;
    let footerLine2=[this.facilityDetails.Address1, this.facilityDetails.City, this.facilityDetails.State, this.facilityDetails.Zip].filter(Boolean).join(", ");
   
     setTimeout(() => {
        try{
        var html = htmlToPdfmake(document.getElementById('printManifest'+this.ShippingManifestID).innerHTML, {
          tableAutoSize: true
        }
        );
        var dd = {
          pageMargins: [ 35, 35, 35, 80 ],
          content: html,
          pageSize:'LETTER',
          pageBreakBefore: function (currentNode:any) {
            return currentNode.style && currentNode.style.indexOf('pdf-pagebreak-before') > -1;
          },
          imagesByReference: true,
          footer: function(currentPage, pageCount) { 
            return  [
              {
                columns:[
                        { width:'100%',
                                      stack:[
                                        {
                                          canvas: [
                                            {
                                                type: 'line',
                                                x1: 30,
                                                y1: 30,
                                                x2: 575,
                                                y2: 30,
                                                lineWidth: 0.8
                                            }
                                        ]
                                        }
                                      ]
                                    }
                         ]
              },
              {
                columns: [  
                {
                  width: '20%',
                  stack:[' ',' ',
                     'Page ' +currentPage.toString() + ' of ' + pageCount,
                    ],
                  alignment:'left'
                },
                {
                  width: '60%',
                  stack:[ footerLine1,
                footerLine2,
                '© '+(new Date()).getFullYear()+' DaVita Inc.',
                ],
                  alignment:'center'
                },
                {
                  width: '20%',
                  stack:[ ' ',
                          'Printed',
                           printFooterDate
                ],
                  alignment:'right'
                }
              ],
              fontSize: 8,
              color:'gray',
              margin:[35,5,35,5]}
            ]
          },
        };

        this.updateShippingManifest();
        pdfMake.createPdf(dd).open();
        
      }
      catch(ex){
        console.log('error in create pdf'+ex);
      } 
      }, 2000);  
    
  }

  updateShippingManifest(){
    let updateShippingManifestParam={
      "UPDATESHIPPINGMANIFEST":{
        "LabRequisitionID":this.labRequisitionIds,
        "LabRequisitionStatusID": this.reprint==false && WorkFlow.HOME==this.workFlow?LabRequisitionStatus.PartiallyShipped: LabRequisitionStatus.Shipped,
        "UserName": this.userInfo.userName,
        "Reprint":this.reprint
      }     
    }
    this._labRequisitionService.updateShippingManifest(JSON.stringify(updateShippingManifestParam)).subscribe(res=>{
      this.pageLoadCompletedEvent.emit();
    },
    err => {
      this._loaderService.hide();
      console.log('error in updateShippingManifest');
    });
  }
  

}
